export enum TypeKeys {
    INITIALIZE = "PREVIEW/INITIALIZE",
}

export const actionCreators = {
    initialize: () => ({ type: TypeKeys.INITIALIZE }),
};
